import state from './moduleServiceState'
import actions from './moduleServiceActions'
import getters from './moduleServiceGetters'
import mutations from './moduleServiceMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}